document.addEventListener( 'DOMContentLoaded', () => {
	// Select all links that have data-scroll attribute or href starting with #
	// Exclude nav-link class which is handled by scroll-animation.js
	const smoothScrollLinks = document.querySelectorAll(
		'a[data-scroll], a[href^="#"]:not([href="#"]):not(.nav-link)'
	);

	smoothScrollLinks.forEach( ( link ) => {
		link.addEventListener( 'click', ( e ) => {
			e.preventDefault();

			// Get the target ID from the href attribute
			const targetId = link.getAttribute( 'href' );

			// Only proceed if it's an anchor link
			if ( targetId && targetId.startsWith( '#' ) ) {
				const targetElement = document.querySelector( targetId );

				if ( targetElement ) {
					// Calculate any offset (e.g., fixed header)
					const navHeight = document.querySelector( 'header' )
						? document.querySelector( 'header' ).offsetHeight
						: 0;

					// Calculate the position to scroll to
					const targetPosition =
						targetElement.getBoundingClientRect().top +
						window.scrollY -
						navHeight;

					// Perform the smooth scroll
					window.scrollTo( {
						top: targetPosition,
						behavior: 'smooth',
					} );
				}
			}
		} );
	} );
} );
